import React from 'react';

/**
 * Icon-only expander affordance. Parents that need a control wrap this in a
 * button.
 */
const ExpandRightArrow = ({ onClick }: { onClick?: () => void }) => {
  return (
    <span
      className="button--icon sml border-0"
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick();
              }
            }
          : undefined
      }
    >
      <i className="material-symbols-outlined">arrow_right</i>
    </span>
  );
};

export default ExpandRightArrow;
